const isCordova = false;
export var PositionWatcherError;
(function (PositionWatcherError) {
    PositionWatcherError[PositionWatcherError["PERMISSION_DENIED"] = 0] = "PERMISSION_DENIED";
    PositionWatcherError[PositionWatcherError["POSITION_UNAVAILABLE"] = 1] = "POSITION_UNAVAILABLE";
    PositionWatcherError[PositionWatcherError["TIMEOUT"] = 2] = "TIMEOUT";
    PositionWatcherError[PositionWatcherError["OTHER"] = 3] = "OTHER";
})(PositionWatcherError || (PositionWatcherError = {}));
export default class PositionWatcher {
    constructor(model) {
        this._startWatchingPosition = () => {
            this.clearWatch();
            if (isCordova) {
                cordova.plugins.diagnostic.registerLocationStateChangeHandler((state) => {
                    if (!this._stateIsAvailable(state)) {
                        this._setError(PositionWatcherError.POSITION_UNAVAILABLE);
                    }
                });
            }
            this._watchId = navigator.geolocation.watchPosition(this._onPositionChanged, this._onPositionError, { enableHighAccuracy: true });
        };
        this._stateIsAvailable = (state) => {
            return (device.platform === 'Android' && state !== cordova.plugins.diagnostic.locationMode.LOCATION_OFF) ||
                (device.platform === 'iOS') && (state === cordova.plugins.diagnostic.permissionStatus.GRANTED ||
                    state === cordova.plugins.diagnostic.permissionStatus.GRANTED_WHEN_IN_USE);
        };
        this._onPositionChanged = (position) => {
            this._setPosition(position);
        };
        this._onPositionError = (e) => {
            let err = undefined;
            switch (e.code) {
                case 1:
                    err = PositionWatcherError.PERMISSION_DENIED;
                    break;
                case 2:
                    err = PositionWatcherError.POSITION_UNAVAILABLE;
                    break;
                case 3:
                    err = PositionWatcherError.TIMEOUT;
                    break;
                default:
                    err = PositionWatcherError.OTHER;
            }
            this._setError(err);
        };
        this._setError = (e, message) => {
            this.clearWatch();
            this._model.position = undefined;
            this._model.error = { message, code: e };
            if (isCordova) {
                cordova.plugins.diagnostic.registerLocationStateChangeHandler((state) => {
                    if (this._stateIsAvailable(state)) {
                        this.watchPosition();
                    }
                });
            }
        };
        this._setPosition = (p) => {
            this._model.position = p;
            this._model.error = undefined;
        };
        this.watchPosition = () => {
            this._model.error = undefined;
            this.clearWatch();
            if (isCordova) {
                const diagnostic = cordova.plugins.diagnostic;
                const checkEnabledAndStart = () => diagnostic.isLocationEnabled((enabled) => {
                    if (enabled) {
                        this._startWatchingPosition();
                    }
                    else {
                        this._setError(PositionWatcherError.POSITION_UNAVAILABLE);
                    }
                }, (error) => {
                    this._setError(PositionWatcherError.OTHER, error);
                });
                diagnostic.isLocationAuthorized((authorized) => {
                    if (authorized) {
                        checkEnabledAndStart();
                    }
                    else {
                        diagnostic.requestLocationAuthorization((status) => {
                            if (status === diagnostic.permissionStatus.GRANTED
                                || status === diagnostic.permissionStatus.GRANTED_WHEN_IN_USE) {
                                checkEnabledAndStart();
                            }
                            else {
                                this._setError(PositionWatcherError.PERMISSION_DENIED);
                            }
                        }, (authRequestError) => {
                            this._setError(PositionWatcherError.OTHER, authRequestError);
                        }, cordova.plugins.diagnostic.locationAuthorizationMode.ALWAYS);
                    }
                }, (authError) => {
                    this._setError(PositionWatcherError.OTHER, authError);
                });
            }
            else {
                this._startWatchingPosition();
            }
        };
        this.clearWatch = () => {
            if (this._watchId) {
                navigator.geolocation.clearWatch(this._watchId);
                this._watchId = undefined;
            }
            if (isCordova) {
                const diagnostic = cordova.plugins.diagnostic;
                // TODO PR in github to add false to parameters
                diagnostic.registerLocationStateChangeHandler(false);
            }
        };
        if (model) {
            this._model = model;
        }
        else {
            this._model = {};
        }
    }
    get position() { return this._model.position; }
    get error() { return this._model.error; }
}
